import React from 'react';
import PropTypes from 'prop-types';
import { RideGlError } from '@rimac-seguros/ride-system-components';

const MobileClinic = ({
  plan, title, price, setPopupActivo, location,
}) => {
  const cerrarPoppup = () => {
    setPopupActivo(false);
  };

  return (
    <div className="buttonspopup__container">
      <div className="buttonspopup__sombreado" onClick={cerrarPoppup} />
      <div className="buttonspopup__popup mobile-clinic__popup">
        <div className="mobile-clinic__header">
          <div className="mobile-clinic__cerrar" onClick={cerrarPoppup}>
            <RideGlError size="x-large" />
          </div>
        </div>
        <div className="mobile-clinic__body">
          <h5>{plan}</h5>
          <div className="mobile-clinic__title">
            <i>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  // eslint-disable-next-line max-len
                  d="M18 8.25212H15V2.23492H4.49857V12.404C4.04289 12.6671 3.6645 13.0455 3.40144 13.5012C3.13838 13.9569 2.99993 14.4738 3 15V21.0028H21V11.2607C21.0008 10.8661 20.9237 10.4753 20.7733 10.1105C20.6229 9.74567 20.4021 9.41408 20.1235 9.13467C19.8449 8.85526 19.514 8.6335 19.1496 8.48207C18.7852 8.33063 18.3946 8.25249 18 8.25212ZM10.4986 19.5014H9V16.5014H10.4986V19.5014ZM19.4986 19.5014H12V15H7.49857V19.5014H4.49857V15C4.49933 14.6023 4.65785 14.2211 4.93934 13.9401C5.22083 13.6592 5.60229 13.5014 6 13.5014V3.74209H13.4986V14.2521H18V12.7507H15.7507V9.75928H18C18.197 9.75928 18.3921 9.79813 18.5741 9.87362C18.7561 9.94911 18.9215 10.0598 19.0607 10.1992C19.1999 10.3387 19.3102 10.5042 19.3853 10.6864C19.4605 10.8685 19.4989 11.0637 19.4986 11.2607V19.5014ZM13.4986 15.7507H18V17.2521H13.4986V15.7507ZM10.4986 6.75068H12V8.25212H10.4986V9.75928H9V8.25212H7.49857V6.75068H9V5.24925H10.4986V6.75068Z"
                  fill="#141938"
                />
              </svg>
            </i>
            <span>{title}</span>
          </div>
          <div className="mobile-clinic__item">
            <span>Ubicación: </span>
            <b>{location || 'Lima'}</b>
          </div>
          <div className="mobile-clinic__item">
            <span>Consulta médica: </span>
            <b>
              S/
              {price}
            </b>
          </div>
        </div>
      </div>
    </div>
  );
};

MobileClinic.defaultProps = {
  location: '',
};

MobileClinic.propTypes = {
  plan: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  setPopupActivo: PropTypes.func.isRequired,
  location: PropTypes.string,
};

export default MobileClinic;
